import { render, staticRenderFns } from "./AddPaymentMessageComponent.vue?vue&type=template&id=36670334&"
import script from "./AddPaymentMessageComponent.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports